import React from "react";
import { FaTrophy, FaGlobe, FaUsers, FaClock, FaRocket } from "react-icons/fa";
import { FaEye, FaBullseye } from "react-icons/fa";
import "./AboutUs.css";

const AboutUs = () => {
  const historyData = [
    {
      year: "2015",
      icon: <FaClock />,
      description: "Started as a small community organizing local badminton tournaments.",
    },
    {
      year: "2017",
      icon: <FaTrophy />,
      description: "Hosted our first national-level badminton championship with 500+ participants.",
    },
    {
      year: "2019",
      icon: <FaGlobe />,
      description: "Expanded into international tournaments, collaborating with top players.",
    },
    {
      year: "2021",
      icon: <FaUsers />,
      description: "Introduced online match tracking, allowing players to view live scores.",
    },
    {
      year: "2023",
      icon: <FaRocket />,
      description: "Launched our official platform, providing seamless registration and updates.",
    },
  ];

  return (
    <div className="about-us">
      <h1 className="title">About Us</h1>

      {/* History Section - Attractive Timeline */}
      <section className="history">
        <h2>Our History</h2>
        <div className="timeline">
          {historyData.map((event, index) => (
            <div
              className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}
              key={index}
            >
              <div className="timeline-icon">{event.icon}</div>
              <div className="timeline-content">
                <h3>{event.year}</h3>
                <p>{event.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section className="vision-mission">
        <div className="card1 vision">
          <div className="card1-icon">
            <FaEye />
          </div>
          <h2>Our Vision</h2>
          <p>
            To become the leading platform for badminton tournaments worldwide, fostering
            sportsmanship and competitive excellence.
          </p>
        </div>

        <div className="card1 mission">
          <div className="card1-icon">
            <FaBullseye />
          </div>
          <h2>Our Mission</h2>
          <p>
            We aim to provide seamless tournament experiences, promote inclusivity in
            sports, and create a thriving community of badminton enthusiasts.
          </p>
          
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
